import { Controller, type UseFormReturn } from "react-hook-form";

import { ContactGenre } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { SelectFieldNew } from "@/components/ui/form/fields-new/select-field";
import { Label } from "@/components/ui/label/label";

import type { ContactCreateInputZodSchemaType } from "../../../../schema";

type Props = {
	form: UseFormReturn<ContactCreateInputZodSchemaType>;
};

const options: FormOptionType[] = [
	{
		id: ContactGenre.HostSettings,
		label: "設定・操作方法に関するお問い合わせ",
		value: ContactGenre.HostSettings,
	},
	{ id: ContactGenre.GuestReservation, label: "既存予約に関するお問い合わせ", value: ContactGenre.GuestReservation },
	{ id: ContactGenre.Others, label: "その他のお問い合わせ", value: ContactGenre.Others },
];

export const SelectGenre = ({ form }: Props) => {
	const {
		control,
		formState: { errors },
	} = form;

	return (
		<Controller
			name="contactGenre"
			control={control}
			render={({ field }) => (
				<SelectFieldNew
					label={
						<div className="space-y-1">
							<div className="flex items-center gap-x-2">
								<p>カテゴリ</p>
								<Label size="sm" text="必須" />
							</div>
							<p className="text-xs text-zinc-500">該当するお問い合わせ内容を選択してください</p>
						</div>
					}
					className="w-fit"
					value={field.value}
					options={options}
					errorMessage={errors?.contactGenre?.message}
					onValueChange={field.onChange}
				/>
			)}
		/>
	);
};

SelectGenre.displayName = "SelectGenre";
